import {
  useCopyToClipboard
} from "./useCopyToClipboard.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useCopyToClipboard
};
//# sourceMappingURL=index.js.map
